/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import enhance from './components/compose';
import './index.scss';
import Navigation from './components/navigation';
import HomePage from './components/pages/HomePage';
import FakeDetailPage from './components/pages/FakeDetailPage';
import DealershipListPage from './components/dealership/dealershipList.page';
import NotFound from './components/pages/NotFound';
import CallbackPage from './components/pages/CallbackPage';
import LoginPage from './components/pages/LoginPage';
import LogoutPage from './components/pages/LogoutPage';
import VehicleListPage from './components/vehicles/vehicleList.page';

export default class App extends React.Component {
  render() {
    return (
      <Router className="main-layout">
        <div>
          <Route path="*" component={withRouter(enhance.useAuthClient(Navigation))} />
          <Switch>
            <Route path="/" exact component={enhance.useAuthentication(HomePage)} />
            <Route path="/vehicles/:entityId/:alert?" component={enhance.useAuthentication(VehicleListPage)} />
            <Route path="/better-fake-vdp/:entityId/:id" component={enhance.useAuthentication(FakeDetailPage)} />
            <Route path="/dealership-list" component={enhance.useAuthentication(DealershipListPage)} />
            <Route path="/login/callback" exact component={enhance.useAuthClient(CallbackPage)} />
            <Route path="/login" exact component={enhance.useAuthClient(LoginPage)} />
            <Route path="/logout" exact component={enhance.useAuthClient(LogoutPage)} />
            <Route component={withRouter(NotFound)} status={404} />
          </Switch>
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js